export const TITLE_GREY = '#2C2C2E80';
export const BG_GREY = '#E2E2E2';
export const WHITE = '#FFFFFF';
export const SHADOW_BOX = '#4A4A8B1A';
export const ADD_GREEN = '#00CA14';
export const PRIMARY_BLUE = '#007AFF';
export const ERROR_RED = '#E53E3E';
